var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.041 17.041h-2.963v-4.64c0-1.107-.02-2.532-1.541-2.532-1.544 0-1.78 1.206-1.78 2.45v4.722H7.794V7.497h2.845v1.305h.04a3.122 3.122 0 0 1 2.806-1.542c3.004 0 3.558 1.976 3.558 4.546l-.002 5.235ZM4.45 6.193c-.944 0-1.72-.776-1.72-1.72 0-.943.776-1.72 1.72-1.72.943 0 1.72.777 1.72 1.72s-.777 1.72-1.72 1.72ZM5.932 17.04H2.965V7.497h2.967v9.544ZM18.519.001H1.476A1.466 1.466 0 0 0 0 1.443v17.114c.01.8.675 1.452 1.476 1.443h17.043A1.47 1.47 0 0 0 20 18.557V1.442A1.469 1.469 0 0 0 18.52 0v.001Z","fill":"currentColor"}));
}

Linkedin.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
